"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TooltipTextRequestModel {
    constructor(visualIdPresModel, tupleId) {
        this.visualIdPresModel = visualIdPresModel;
        this.tupleId = tupleId;
    }
}
exports.TooltipTextRequestModel = TooltipTextRequestModel;
//# sourceMappingURL=AccessibilityModels.js.map